import { FunctionComponent } from "react";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import {
  RadioGroupWithRegister,
  TextInputWithRegister,
} from "src/components/inputs";
import { NEATTOptions } from "src/utils/types";

interface IEmploymentInformationFormProps {
  register: UseFormRegister<any>;
  errors: FieldErrors;
  employment: string;
}

const EmploymentInformationForm: FunctionComponent<IEmploymentInformationFormProps> = ({ register, errors, employment }) => (
  <form className="grid grid-cols-2 gap-6">
    <RadioGroupWithRegister
      question="What is your current employment status?"
      name="employmentStatus"
      register={register}
      options={NEATTOptions.EmploymentStatus}
      error={`${errors?.employmentStatus?.message || ""}`}
    />

    {(employment === "fulltime" ||
      employment === "parttime" ||
      employment === "self") && (
      <TextInputWithRegister
        register={register("employmentDuration")}
        label="How long have you been with your current employer?"
        id="employmentDuration"
        placeholder="10 months, 3 years"
        containerStyles="max-w-[350px]"
        error={`${errors?.employmentDuration?.message || ""}`}
      />
    )}

    <RadioGroupWithRegister
      question="Are you currently renting or do you own property?"
      name="livingStatus"
      register={register}
      options={NEATTOptions.LivingSituation}
      error={`${errors?.livingStatus?.message || ""}`}
    />

    <TextInputWithRegister
      register={register("addressDuration")}
      label="How long have you lived at your current address?"
      id="addressDuration"
      placeholder="X years"
      containerStyles="max-w-[350px]"
      error={`${errors?.addressDuration?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Do you anticipate any significant changes in your income in the next year?"
      name="changesToIncomeOverYear"
      register={register}
      options={NEATTOptions.YesNoUnsureOptions}
      error={`${errors?.changesToIncomeOverYear?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Are you comfortable providing additional financial documentation if needed?"
      name="documentationConsent"
      register={register}
      options={NEATTOptions.YesNoOptions}
      error={`${errors?.documentConsent?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Do you have any additional sources of income?"
      name="additionalIncome"
      register={register}
      options={NEATTOptions.YesNoOptions}
      error={`${errors?.additionalIncome?.message || ""}`}
    />
  </form>
);

export default EmploymentInformationForm;
